export const getCustomerId = async () => {
  try {
    // A lot can go wrong here, but let it fail if it does.
    const res = await fetch('/wra/auth');
    const json = await res.json();
    const encodedJwtClaims = json.accountInfo.jwt.split('.')[1];
    const jwtClaims = JSON.parse(atob(encodedJwtClaims));
    return jwtClaims.cid;
  } catch (err) {
    console.log('Failed to get customer id', err);
    return 'UNKNOWN';
  }
};
